import { ComponentProps } from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";
import { DatePicker } from "../DatePicker";

type DatePickerProps = ComponentProps<typeof DatePicker>;

interface FormDatePickerProps<TFieldValues extends FieldValues>
  extends DatePickerProps {
  name: UseControllerProps<TFieldValues>["name"];
  control: UseControllerProps<TFieldValues>["control"];
}

const FormDatePicker = <TFieldValues extends FieldValues>({
  name,
  control,
  ...rest
}: FormDatePickerProps<TFieldValues>) => {
  const { field, fieldState } = useController({ name, control });
  return <DatePicker {...rest} {...field} error={fieldState.error?.message} />;
};

export { FormDatePicker };
